
import imageCompression from "browser-image-compression";
import { useGlobalContext } from "../../GlobalContext";
import { toast } from "sonner";

export default function useKYCImageUpload() {
const { bumppyApi, AdminId } = useGlobalContext();

  const compressImageMax = async (file) => {
    const options = {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 600,
      useWebWorker: true,
      fileType: "image/jpeg",
      quality: 0.7,
    };

    const compressedFile = await imageCompression(file, options);

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = String(reader.result || "");

        const base64 = result.replace(
          /^data:image\/(jpeg|png|webp|jpg);base64,/,
          ""
        );

        resolve(base64);
      };

      reader.onerror = reject;
      reader.readAsDataURL(compressedFile);
    });
  };

const uploadImageToServer = async (file, userId, type, itemName) => {
  if (!file) return "";
  if (typeof file === "string") return file;

  if (!userId) {
    toast.error("User ID is required for image upload");
    return "";
  }

  if (!type) {
    toast.error("Image type is required");
    return "";
  }

  if (file.size > 5 * 1024 * 1024) {
    throw new Error("Image too large (max 5MB)");
  }

  try {
    const base64 = await compressImageMax(file);

    const payload = {
      userid: String(userId),
      item_name: itemName || `${userId}_${type}`,
      image_data: base64,
      type: String(type),
      adminId: String(AdminId || ""),
    };

   const res = await bumppyApi.post(
  "/v1/uploadKycImagev2.php",
  payload,
);

    if (String(res?.data?.status) === "0") {
      return (
        res.data?.image_url ||
        `https://bumppy.in/packky/uploads/kyc/${userId}_${type}.jpg`
      );
    }

    throw new Error(
      res?.data?.msg ||
        res?.data?.message ||
        "Upload failed",
    );
  } catch (err) {
    console.error(
      "uploadImageToServer error:",
      err?.response?.data || err,
    );

    toast.error(
      err?.response?.data?.msg ||
        err?.response?.data?.message ||
        err?.message ||
        "Image upload failed",
    );

    throw err;
  }
};

  return {
    compressImageMax,
    uploadImageToServer,
  };
}